<template>
  <!-- 学生画像 -->
  <div class="page">
    <div :style="{ filter: this.$store.state.isVague ? 'blur(2px)' : '' }">
      <el-row :gutter="12" class="firstFloor">
        <el-col :span="8">
          <div class="grid-content record">
            <div class="dataSources">
              <div class="generalBg_Virtualization"></div>
              <div class="header">
                <div class="header_Virtualization"></div>
                <div class="header_title">
                  <i class="h_icon header-icon"></i>
                  <span style="margin-right: 20px">性别分布</span>
                </div>
                <i class="threePoints el-icon-more"></i>
              </div>
              <div class="standards_content echartsHeight">
                <circularChart
                  :refId="'genderChart'"
                  :datas="gender.dataList"
                  :colorName="'1'"
                  :innerText="'数量'"
                  />
              </div>
            </div>

            <div class="picture">
              <div class="generalBg_Virtualization"></div>
              <div class="header">
                <div class="header_Virtualization"></div>
                <div class="header_title">
                  <i class="h_icon header-icon"></i>
                  <span>生源类型分布</span>
                </div>
                <i class="threePoints el-icon-more"></i>
              </div>
              <div class="standards_content echartsHeight">
                <circularChart
                  :refId="'typeChart'"
                  :datas="type.dataList"
                  :colorName="'1'"
                  :innerText="'数量'"
                />
              </div>
            </div>
          </div>
        </el-col>
        <el-col :span="16">
          <div class="grid-content">
            <div class="generalBg_Virtualization"></div>
            <div class="header">
              <div class="header_Virtualization"></div>
              <div class="header_title">
                <i class="h_icon header-icon"></i>
                <span>学生所在地域分布</span>
              </div>
              <i class="threePoints el-icon-more"></i>
            </div>
            <div class="standards_content">
              <div style="width: 100%; height: 730px">
                <distributionCharts
                  :refId="'participatingChart'"
                  :datas="participating.dataList"
                  />
              </div>
            </div>
          </div>
        </el-col>
      </el-row>

      <!-- 第二层 -->
      <el-row :gutter="12" class="sameLayer">
        <el-col :span="8">
          <div class="grid-content">
            <div class="generalBg_Virtualization"></div>
            <div class="header">
              <div class="header_Virtualization"></div>
              <div class="header_title">
                <i class="h_icon header-icon"></i>
                <span>专业分布</span>
              </div>
              <i class="threePoints el-icon-more"></i>
            </div>
            <div class="standards_content echartsHeight">
              <vcolumnarChart
                :refId="'professionalChart'"
                :datas="professional.dataList"
                :transverseData="professional.transverseData"
                :colorList="professional.colorList"
                :innerText="'单位：人'"
                />
            </div>
          </div>
        </el-col>
        <el-col :span="8">
          <div class="grid-content">
            <div class="generalBg_Virtualization"></div>
            <div class="header">
              <div class="header_Virtualization"></div>
              <div class="header_title">
                <i class="h_icon header-icon"></i>
                <span>参建院校实名学生占比</span>
              </div>
              <i class="threePoints el-icon-more"></i>
            </div>
            <div class="standards_content echartsHeight">
              <meterChart
                :datas="participatingInstitutions.dataList"
                :colorList="participatingInstitutions.colorList"
                />
            </div>
          </div>
        </el-col>
        <el-col :span="8">
          <div class="grid-content">
            <div class="generalBg_Virtualization"></div>
            <div class="header">
              <div class="header_Virtualization"></div>
              <div class="header_title">
                <i class="h_icon header-icon"></i>
                <span>实名学生无活动占比</span>
              </div>
              <i class="threePoints el-icon-more"></i>
            </div>
            <div class="standards_content echartsHeight">
              <meterChart
                :datas="inactiveStudents.dataList"
                :colorList="inactiveStudents.colorList"
                />
            </div>
          </div>
        </el-col>
      </el-row>

      <el-row :gutter="12" class="sameLayer">
        <el-col :span="24">
          <div class="grid-content">
            <div class="generalBg_Virtualization"></div>
            <div class="header">
              <div class="header_Virtualization"></div>
              <div class="header_title">
                <i class="h_icon header-icon"></i>
                <span>学生用户历年新增数</span>
              </div>
              <i class="threePoints el-icon-more"></i>
            </div>
            <div class="standards_content echartsHeight">
              <discountChart
                :refId="'studentUsersOverYearsChart'"
                :datas="studentUsersOverYears.dataList"
                :transverseData="studentUsersOverYears.transverseData"
                :colorList="studentUsersOverYears.colorList"
                :legendList="studentUsersOverYears.legendList"
                :gridWidth="true"
                :innerText="'单位：人'"
                />
            </div>
          </div>
        </el-col>
      </el-row>

      <el-row :gutter="12" class="sameLayer">
        <el-col :span="24">
          <div class="grid-content">
            <div class="generalBg_Virtualization"></div>
            <div class="header">
              <div class="header_Virtualization"></div>
              <div class="header_title">
                <i class="h_icon header-icon"></i>
                <span>近一年学生用户注册情况</span>
              </div>
              <i class="threePoints el-icon-more"></i>
            </div>
            <div class="standards_content echartsHeight">
              <discountChart
                :refId="'recentYearChart'"
                :datas="recentYear.dataList"
                :transverseData="recentYear.transverseData"
                :colorList="recentYear.colorList"
                :legendList="recentYear.legendList"
                :gridWidth="true"
                :innerText="'单位：人'"
                />
            </div>
          </div>
        </el-col>
      </el-row>

      <el-row :gutter="12" class="sameLayer">
        <el-col :span="24">
          <div class="grid-content">
            <div class="generalBg_Virtualization"></div>
            <div class="header">
              <div class="header_Virtualization"></div>
              <div class="header_title">
                <i class="h_icon header-icon"></i>
                <span>学生访问时间段分布</span>
              </div>
              <i class="threePoints el-icon-more"></i>
            </div>
            <div class="standards_content echartsHeight">
              <discountChart
                :refId="'behaviorChart'"
                :datas="behavior.dataList"
                :transverseData="behavior.transverseData"
                :colorList="behavior.colorList"
                :legendList="behavior.legendList"
                :gridWidth="true"
                :innerText="'单位：人次'"
                />
            </div>
          </div>
        </el-col>
      </el-row>

      <!-- 第六层 -->
      <el-row :gutter="12" class="sameLayer">
        <el-col :span="24">
          <div class="grid-content">
            <div class="generalBg_Virtualization"></div>
            <div class="header">
              <div class="header_Virtualization"></div>
              <div class="header_title">
                <i class="h_icon header-icon"></i>
                <span>近一年学生访问情况</span>
              </div>
              <i class="threePoints el-icon-more"></i>
            </div>
            <div class="standards_content echartsHeight">
              <discountChart
                :refId="'applicationChart'"
                :datas="application.dataList"
                :transverseData="application.transverseData"
                :colorList="application.colorList"
                :legendList="application.legendList"
                :gridWidth="true"
                :innerText="'单位：人次'"
                />
            </div>
          </div>
        </el-col>
      </el-row>

      

      <!-- 第七层 -->
      <el-row :gutter="12" class="sameLayer">
        <el-col :span="12">
          <div class="grid-content">
            <div class="generalBg_Virtualization"></div>
            <div class="header">
              <div class="header_Virtualization"></div>
              <div class="header_title">
                <i class="h_icon header-icon"></i>
                <span>建设单位学生用户数排名 （前10名）</span>
              </div>
              <span
                class="more"
                @click="seeMore(-1, '建设单位学生数排名', rankingStudent.headerList)"
              >
                查看更多
                <i class="el-icon-d-arrow-right"></i>
              </span>
            </div>
            <div class="standards_content echartsHeight">
              <tcolumnarChart
                :refId="'rankingStudentChart'"
                :datas="rankingStudent.dataList"
                :transverseData="rankingStudent.transverseData"
                :colorList="colorList"
                :gridHeight="'78%'"
                />
            </div>
          </div>
        </el-col>
        <el-col :span="12">
          <div class="grid-content">
            <div class="generalBg_Virtualization"></div>
            <div class="header">
              <div class="header_Virtualization"></div>
              <div class="header_title">
                <i class="h_icon header-icon"></i>
                <span>访问资源次数排名</span>
              </div>
              <i class="threePoints el-icon-more"></i>
            </div>
            <div class="standards_content">
              <div style="padding: 15px 15px 0px 15px">
                <tableList
                  :tableData="resourceVisits1.tableList"
                  :headerData="resourceVisits1.headerList"
                ></tableList>
                <div class="viewMore">
                  <el-button
                    v-if="resourceVisits1.tableList.length >= 6"
                    size="small"
                    class="upAndDown"
                    style="margin-left: 0px"
                    @click="seeMore(7, '访问资源次数排名(前100名)', resourceVisits1.headerList)"
                    >查看更多</el-button
                  >
                </div>
              </div>
            </div>
          </div>
        </el-col>
      </el-row>

      <!-- 第八层 -->
      <el-row :gutter="12" type="flex" style="margin-bottom: 10px">
        <el-col :span="12">
          <div class="grid-content bg-purple">
            <div class="generalBg_Virtualization"></div>
            <div class="header">
              <div class="header_Virtualization"></div>
              <div class="header_title">
                <i class="h_icon header-icon"></i>
                <span>访问课程次数排名</span>
              </div>
              <i class="threePoints el-icon-more"></i>
            </div>
            <div class="standards_content">
              <div style="padding: 15px 15px 0px 15px">
                <tableList
                  :tableData="resourceVisits2.tableList"
                  :headerData="resourceVisits2.headerList"
                ></tableList>
                <div class="viewMore">
                  <el-button
                    v-if="resourceVisits2.tableList.length >= 10"
                    size="small"
                    class="upAndDown"
                    style="margin-left: 0px"
                    @click="seeMore(8, '访问课程次数排名(前100名)', resourceVisits2.headerList)"
                    >查看更多</el-button
                  >
                </div>
              </div>
            </div>
          </div>
        </el-col>
        <el-col :span="12">
          <div class="grid-content bg-purple">
            <div class="generalBg_Virtualization"></div>
            <div class="header">
              <div class="header_Virtualization"></div>
              <div class="header_title">
                <i class="h_icon header-icon"></i>
                <span>参与互动次数排名</span>
              </div>
              <i class="threePoints el-icon-more"></i>
            </div>
            <div class="standards_content">
              <div style="padding: 15px 15px 0px 15px">
                <tableList
                  :tableData="resourceVisits3.tableList"
                  :headerData="resourceVisits3.headerList"
                ></tableList>
                <div class="viewMore">
                  <el-button
                    v-if="resourceVisits3.tableList.length >= 10"
                    size="small"
                    class="upAndDown"
                    style="margin-left: 0px"
                    @click="seeMore(9, '参与互动次数排名(前100名)', resourceVisits3.headerList)"
                    >查看更多</el-button
                  >
                </div>
              </div>
            </div>
          </div>
        </el-col>
      </el-row>

      <!-- 第九层 -->
      <el-row :gutter="12" type="flex">
        <el-col :span="12">
          <div class="grid-content bg-purple">
            <div class="generalBg_Virtualization"></div>
            <div class="header">
              <div class="header_Virtualization"></div>
              <div class="header_title">
                <i class="h_icon header-icon"></i>
                <span>完成作业考试次数排名</span>
              </div>
              <i class="threePoints el-icon-more"></i>
            </div>
            <div class="standards_content">
              <div style="padding: 15px; padding-bottom: 0px">
                <tableList
                  :tableData="resourceVisits4.tableList"
                  :headerData="resourceVisits4.headerList"
                ></tableList>
                <div class="viewMore">
                  <el-button
                    v-if="resourceVisits4.tableList.length >= 10"
                    size="small"
                    class="upAndDown"
                    style="margin-left: 0px"
                    @click="
                      seeMore(10, '完成作业考试次数排名(前100名)', resourceVisits4.headerList)
                    "
                    >查看更多</el-button
                  >
                </div>
              </div>
            </div>
          </div>
        </el-col>
        <el-col :span="12">
          <div class="grid-content bg-purple">
            <div class="generalBg_Virtualization"></div>
            <div class="header">
              <div class="header_Virtualization"></div>
              <div class="header_title">
                <i class="h_icon header-icon"></i>
                <span>总访问量排名</span>
              </div>
              <i class="threePoints el-icon-more"></i>
            </div>
            <div class="standards_content">
              <div style="padding: 15px; padding-bottom: 0px">
                <tableList
                  :tableData="resourceVisits5.tableList"
                  :headerData="resourceVisits5.headerList"
                ></tableList>
                <div class="viewMore">
                  <el-button
                    v-if="resourceVisits5.tableList.length >= 10"
                    size="small"
                    class="upAndDown"
                    style="margin-left: 0px"
                    @click="seeMore(11, '总访问量排名(前100名)', resourceVisits5.headerList)"
                    >查看更多</el-button
                  >
                </div>
              </div>
            </div>
          </div>
        </el-col>
      </el-row>
      <el-backtop :bottom="80" target=".page" class="backtops"></el-backtop>
    </div>

    <!-- 表格中查看更多 -->
    <el-dialog
      :title="detailsBox.title"
      :visible.sync="detailsBox.show"
      :close-on-click-modal="false"
      width="600px"
      class="pop_up distribute"
      append-to-body
      :before-close="handleClose"
    >
      <div class="moreBox">
        <tableList
          :tableData="detailsBox.data.tableList"
          :headerData="detailsBox.data.headerList"
        ></tableList>
      </div>
      <div class="tx-center">
        <el-button size="small" @click="handleClose">确 定</el-button>
      </div>
    </el-dialog>

    <!-- 加载组件 -->
    <loading class="loading_box" v-if="this.$store.state.loading"></loading>
  </div>
</template>

<script>
import distributionCharts from "@/components/chart/distributionCharts.vue"; //地图
import circularChart from "@/components/chart/circularChart.vue"; //引入圆形图表
import vcolumnarChart from "@/components/chart/vcolumnarChart.vue"; //引入竖柱状图图表
import tcolumnarChart from "@/components/chart/tcolumnarChart.vue"; //横着的柱状图
import discountChart from "@/components/chart/discountChart.vue"; //引入折现图图表
import meterChart from "@/components/chart/meterChart.vue"; //引入折现图图表
import tableList from "@/components/tableList.vue"; //表格

export default {
  components: {
    distributionCharts,
    circularChart,
    vcolumnarChart,
    tcolumnarChart,
    discountChart,
    meterChart,
    tableList,
  },
  data() {
    return {
      colorList: [
        "#1BF6F8",
        "#3B86FF",
        "#FA4798",
        "#6FE05F",
        "#E0D35F",
        "#5470C6",
        "#DE7E4B",
        "#DE524B",
      ], //柱状图或折线图的颜色
      dashboardColor: [
        ["#E67070", "#E10303"],
        ["#ECB853", "#DF9C0D"],
        ["#43CCB3", "#12A888"],
      ], //仪表盘颜色红，黄，绿

      // 第一层
      gender: {
        // 性别分布
        dataList: [],
      },
      type: {
        // 生源类型分布
        dataList: [],
      },
      participating: {
        //学生所在地域分布
        dataList: [],
      },

      // 第二层
      professional: {
        //专业分布
        dataList: [],
        transverseData: [],
        colorList: [],
      },
      participatingInstitutions: {
        //参建院校实名学生占比
        dataList: 0,
        colorList: [],
      },
      inactiveStudents: {
        //实名学生无活动占比
        dataList: 0,
        colorList: [],
      },

      // 第三层
      studentUsersOverYears: {
        //学生用户历年新增数
        dataList: [],
        transverseData: [],
        colorList: [],
        legendList: [],
      },

      // 第四层
      recentYear: {
        //近一年学生用户注册情况
        dataList: [],
        transverseData: [],
        colorList: [],
        legendList: [],
      },

      // 第五层
      behavior: {
        //学生访问时间段分布
        dataList: [],
        transverseData: [],
        colorList: [],
        legendList: [],
      },

      // 第六层
      application: {
        //近一年学生访问情况
        dataList: [],
        transverseData: [],
        colorList: [],
        legendList: [],
      },

      // 第七层
      rankingStudent: {
        //建设单位学生用户数排名 （前10名）
        dataList: [],
        transverseData: [],
        tableList:[],
        headerList: [
          {
            name: "序号",
            prop: "index",
          },
          {
            name: "院校名称",
            prop: "name",
          },
          {
            name: "学生数",
            prop: "value",
          },
        ],
      },
      // 访问资源次数排名
      resourceVisits1: {
        tableList: [],
        headerList: [],
      },

      // 第八层
      resourceVisits2: {
        tableList: [],
        headerList: [],
      },
      resourceVisits3: {
        tableList: [],
        headerList: [],
      },

      // 第九层
      resourceVisits4: {
        tableList: [],
        headerList: [],
      },
      resourceVisits5: {
        tableList: [],
        headerList: [],
      },

      // 弹窗
      detailsBox: {
        title: "",
        show: false,
        data: {
          tableList: [],
          headerList: [],
        },
      },
    };
  },
  created() {
    // 第一层
    this.genderDom();
    this.typeDom();
    this.participatingDom();

    // 第二层
    this.professionalDom();
    this.participatingInstitutionsDom();
    this.inactiveStudentsDom();

    // 第三层
    this.studentUsersOverYearsDom();

    // 第四层
    this.recentYearDom();

    // 第五层
    this.behaviorDom();

    // 第六层
    this.applicationDom();

    // 第七层
    this.rankingStudentDom();
    this.resourceVisits1Dom();

    // 第八层
    this.resourceVisits2Dom();
    this.resourceVisits3Dom();

    // 第九层
    this.resourceVisits4Dom();
    this.resourceVisits5Dom();
  },
  methods: {
    // 第一层
    // 性别分布
    genderDom() {
      this.$axios
        .post(this.$apiurls.studentPortrait_getStudentSexEchart, {
          loading: false,
        })
        .then((res) => {
          if (res) {
            this.gender.dataList = res.data;
          }
        });
    },
    // 生源类型分布
    typeDom() {
      this.$axios
        .post(this.$apiurls.studentPortrait_getStudentTypeEchart, {
          loading: false,
        })
        .then((res) => {
          if (res) {
            this.type.dataList = res.data;
          }
        });
    },
    // 学生所在地域分布
    participatingDom() {
      this.$axios
        .post(this.$apiurls.studentPortrait_getStudentProvinceUsersEchart, {
          loading: false,
        })
        .then((res) => {
          if (res) {
            this.participating.dataList = res.data;
          }
        });
    },

    // 第二层
    // 专业分布
    professionalDom() {
      this.$axios
        .post(this.$apiurls.studentPortrait_getStudentProfessionalEchart, {
          loading: false,
        })
        .then((res) => {
          if (res) {
            this.professional.transverseData = res.data.name;
            this.professional.dataList = res.data.value;
            this.professional.colorList = this.colorList;
          }
        });
    },
    // 参建院校实名学生占比
    participatingInstitutionsDom() {
      this.$axios
        .post(this.$apiurls.overallPortrait_getRealNameStudentsInParticipatingInstitutions, {
          loading: false,
        })
        .then((res) => {
          if (res) {
            var value = res.data;
            this.participatingInstitutions.dataList = value;
            if (value <= 90) {
              this.participatingInstitutions.colorList = this.dashboardColor[0];
            } else {
              this.participatingInstitutions.colorList = this.dashboardColor[2];
            }
          }
        });
    },
    // 实名学生无活动占比
    inactiveStudentsDom() {
      this.$axios
        .post(this.$apiurls.overallPortrait_getProportionOfInactiveStudents, {
          loading: false,
        })
        .then((res) => {
          if (res) {
            var value = res.data;
            this.inactiveStudents.dataList = value;
            if (value >= 10) {
              this.inactiveStudents.colorList = this.dashboardColor[0];
            } else if (value >= 8 && value < 10) {
              this.inactiveStudents.colorList = this.dashboardColor[1];
            } else {
              this.inactiveStudents.colorList = this.dashboardColor[2];
            }
          }
        });
    },

    // 第三层
    // 学生用户历年新增数
    studentUsersOverYearsDom() {
      this.$axios
        .post(this.$apiurls.studentPortrait_getUserByYearAddCountEchart, {
          loading: false,
        })
        .then((res) => {
          if (res) {
            this.studentUsersOverYears.transverseData = res.data.name;
            this.studentUsersOverYears.dataList = res.data.value;
            this.studentUsersOverYears.colorList = this.colorList;
            this.studentUsersOverYears.legendList = [];
          }
        });
    },

    // 第四层
    // 近一年学生用户注册情况
    recentYearDom() {
      this.$axios
        .post(this.$apiurls.studentPortrait_getStudentByMonthRegisterCountEchart, {
          loading: false,
        })
        .then((res) => {
          if (res) {
            this.recentYear.transverseData = res.data.name;
            this.recentYear.dataList = res.data.value;
            this.recentYear.colorList = this.colorList;
            this.recentYear.legendList = [];
          }
        });
    },

    // 第五层
    //学生访问时间段分布
    behaviorDom() {
      this.$axios
        .post(this.$apiurls.studentPortrait_getStudentActionTimeDistributionEchart, {
          loading: false,
        })
        .then((res) => {
          if (res) {
            this.behavior.transverseData = res.data.name;
            this.behavior.dataList = res.data.value;
            this.behavior.colorList = this.colorList;
            this.behavior.legendList = [];
          }
        });
    },

    // 第六层
    //近一年学生访问情况
    applicationDom() {
      this.$axios
        .post(this.$apiurls.studentPortrait_getStudentActionApplicationByYearEchart, {
          loading: false,
        })
        .then((res) => {
          if (res) {
            this.application.transverseData = res.data.name;
            this.application.dataList = res.data.value;
            this.application.colorList = this.colorList;
            this.application.legendList = [];
          }
        });
    },

    // 第七层
    //建设单位学生用户数排名 （前10名）
    rankingStudentDom() {
      this.$axios
        .post(this.$apiurls.studentPortrait_getConstructionUnitStudentCountEchart, {
          loading: false,
        })
        .then((res) => {
          if (res.code === 200) {
            let name = res.data.name;
            this.rankingStudent.transverseData = name.slice(0, 10);
            let value = res.data.value;
            this.rankingStudent.dataList = value.slice(0, 10);
            let arr = [];
            for (let i = 0; i < name.length; i++) {
              arr.push({
                index: i + 1,
                name: name[i],
                value: value[i],
              });
            }
            console.log(arr);
            this.rankingStudent.tableList = arr;
          }
        });
    },
    // 访问资源次数排名
    resourceVisits1Dom() {
      this.$axios
        .post(
          this.$apiurls.studentPortrait_getStudentVisitCountRankByType,
          {
            limitNum: "7",
            statType: 7,
          },
          {
            loading: false,
          }
        )
        .then((res) => {
          if (res) {
            if (res.data.length >= 7) {
              res.data.splice(res.data.length - 1, 1);
            }
            this.resourceVisits1.tableList = res.data;
            this.resourceVisits1.headerList = [
              {
                name: "序号",
                prop: "index",
              },
              {
                name: "姓名",
                prop: "name",
              },
              {
                name: "院校",
                prop: "school",
              },
              {
                name: "专业",
                prop: "profession",
              },
              {
                name: "访问次数",
                prop: "num",
              },
            ];
          }
        });
    },

    // 第八层访问表格
    resourceVisits2Dom() {
      this.$axios
        .post(
          this.$apiurls.studentPortrait_getStudentVisitCountRankByType,
          {
            limitNum: "11",
            statType: 8,
          },
          {
            loading: false,
          }
        )
        .then((res) => {
          if (res) {
            if (res.data.length >= 11) {
              res.data.splice(res.data.length - 1, 1);
            }
            this.resourceVisits2.tableList = res.data;
            this.resourceVisits2.headerList = [
              {
                name: "序号",
                prop: "index",
              },
              {
                name: "姓名",
                prop: "name",
              },
              {
                name: "院校",
                prop: "school",
              },
              {
                name: "专业",
                prop: "profession",
              },
              {
                name: "访问次数",
                prop: "num",
              },
            ];
          }
        });
    },
    resourceVisits3Dom() {
      this.$axios
        .post(
          this.$apiurls.studentPortrait_getStudentVisitCountRankByType,
          {
            limitNum: "11",
            statType: 9,
          },
          {
            loading: false,
          }
        )
        .then((res) => {
          if (res) {
            if (res.data.length >= 11) {
              res.data.splice(res.data.length - 1, 1);
            }
            this.resourceVisits3.tableList = res.data;
            this.resourceVisits3.headerList = [
              {
                name: "序号",
                prop: "index",
              },
              {
                name: "姓名",
                prop: "name",
              },
              {
                name: "院校",
                prop: "school",
              },
              {
                name: "专业",
                prop: "profession",
              },
              {
                name: "互动次数",
                prop: "num",
              },
            ];
          }
        });
    },

    // 第九层访问表格
    resourceVisits4Dom() {
      this.$axios
        .post(
          this.$apiurls.studentPortrait_getStudentVisitCountRankByType,
          {
            limitNum: "11",
            statType: 10,
          },
          {
            loading: false,
          }
        )
        .then((res) => {
          if (res) {
            if (res.data.length >= 11) {
              res.data.splice(res.data.length - 1, 1);
            }
            this.resourceVisits4.tableList = res.data;
            this.resourceVisits4.headerList = [
              {
                name: "序号",
                prop: "index",
              },
              {
                name: "姓名",
                prop: "name",
              },
              {
                name: "院校",
                prop: "school",
              },
              {
                name: "专业",
                prop: "profession",
              },
              {
                name: "参与作业/考试次数",
                prop: "num",
              },
            ];
          }
        });
    },
    resourceVisits5Dom() {
      this.$axios
        .post(
          this.$apiurls.studentPortrait_getStudentVisitCountRankByType,
          {
            limitNum: "11",
            statType: 11,
          },
          {
            loading: false,
          }
        )
        .then((res) => {
          if (res) {
            if (res.data.length >= 11) {
              res.data.splice(res.data.length - 1, 1);
            }
            this.resourceVisits5.tableList = res.data;
            this.resourceVisits5.headerList = [
              {
                name: "序号",
                prop: "index",
              },
              {
                name: "姓名",
                prop: "name",
              },
              {
                name: "院校",
                prop: "school",
              },
              {
                name: "专业",
                prop: "profession",
              },
              {
                name: "访问量",
                prop: "num",
              },
            ];
          }
        });
    },
    // 查看更多
    seeMore(index, title, headerList) {
      this.$store.commit("isLoading", true);
      this.detailsBox.data.tableList = [];
      if (index === -1) {
        this.showTable(this.rankingStudent.tableList, title, headerList);
      } else
        this.$axios
          .post(
            this.$apiurls.studentPortrait_getStudentVisitCountRankByType,
            {
              limitNum: "100",
              statType: index,
            },
            {
              loading: false,
            }
          )
          .then((res) => {
            if (res.code === 200) {
              this.showTable(res.data, title, headerList);
            }
          })
          .catch((_) => {
            this.$store.commit("isLoading", false);
          });
    },
    showTable(data, title, headerList) {
      this.detailsBox.show = true;
      this.detailsBox.data.tableList = data;
      this.detailsBox.data.headerList = headerList;
      this.detailsBox.title = title;
      this.$store.commit("modifyVague", true);
      this.$store.commit("isLoading", false);
    },
    // 关闭弹窗
    handleClose() {
      this.detailsBox.show = false;
      this.$store.commit("modifyVague", false);
      this.$store.commit("isLoading", false);
    },
  },
};
</script>

<style lang="scss" src="@/assets/css/popUp.scss" scoped></style>
<style lang="scss" src="@/assets/css/table.scss" scoped></style>
<style lang="scss" scoped>
/* 第一层 */
.firstFloor {
  height: 796px;
  position: relative;
  margin-bottom: 12px;
}

.firstFloor .el-col-16 {
  height: 100%;
}

/* 性别分布 */
.dataSources {
  position: relative;
  width: 100%;
  margin-bottom: 12px;
}

/* 生源类型分布 */
.picture {
  position: relative;
  width: 100%;
}

.firstFloor .echartsHeight {
  width: 100%;
  height: 352px;
}

/* 第二层 ,第三层 ,第四层 */
.sameLayer {
  position: relative;
  margin-bottom: 12px;
}

.sameLayer .el-col {
  height: 400px;
}

.sameLayer .echartsHeight {
  width: 100%;
  height: 380px;
}

// 带legend
.beltLegend .el-col {
  height: 420px;
}

.moreBox {
  height: 550px;
  overflow-y: auto;
}
.tx-center {
  margin-top: 10px;
}
.more {
  cursor: pointer;
  color: #1bf6f8;
  z-index: 1;
  font-size: 12px;
  padding-right: 10px;
}
</style>
